<div class="statistics-overview">

  <div class="statistics-overview__cards">

    <section class="statistics-card statistics-card--balance">
      <header class="statistics-card__header">
        <h2>{{ 'statistics.balance.title' | transloco: {year: response.year} }}</h2>
        <span class="statistics-card__hint">{{ 'statistics.balance.scope' | transloco }}</span>
        <span class="statistics-card__check">
          <i class="pi pi-check"></i>{{ balanceEquation }} · {{ 'statistics.balance.checksOut' | transloco }}
        </span>
      </header>

      <div class="statistics-balance">
        @for (item of balanceItems; track item.label) {
          <div class="statistics-balance__item">
            @if (item.operator) {
              <span class="statistics-balance__operator">{{ item.operator }}</span>
            }
            <div class="statistics-balance__body">
              <div class="statistics-balance__label">{{ item.label }}</div>
              <div class="statistics-balance__value" [class.statistics-balance__value--result]="item.isResult">
                {{ item.value | statCount }}
              </div>
              @if (compareWithPreviousYear) {
                <div class="statistics-balance__delta">
                  {{ item.delta ?? ('statistics.balance.noPreviousYear' | transloco) }}
                </div>
              }
              <div class="statistics-balance__note">{{ item.note }}</div>
            </div>
          </div>
        }
      </div>
    </section>

    <section class="statistics-card">
      <header class="statistics-card__header">
        <h2>{{ 'statistics.split.title' | transloco: {label: endLabel} }}</h2>
        <span class="statistics-card__hint">
          {{ 'statistics.split.subtitle' | transloco: {count: response.total.stockAtPeriodEnd} }}
        </span>
      </header>

      <div class="statistics-split">
        @for (split of splits; track split.title) {
          <div class="statistics-split__group">
            <div class="statistics-split__head">
              <span class="statistics-split__title">{{ split.title }}</span>
              <span class="statistics-split__equation">{{ split.equation }}</span>
            </div>
            <div class="statistics-split__bar">
              @for (segment of split.segments; track segment.label) {
                @if (segment.count > 0) {
                  <span
                    class="statistics-split__segment"
                    [style.flex-grow]="segment.count"
                    [style.background]="segment.color"
                    [pTooltip]="segment.label + ': ' + (segment.count | statCount)">
                  </span>
                }
              }
            </div>
            <div class="statistics-split__legend">
              @for (segment of split.segments; track segment.label) {
                <span class="statistics-split__legend-item">
                  <span class="statistics-split__dot" [style.background]="segment.color"></span>
                  {{ segment.label }}
                  <strong [class.statistics-overview__zero]="segment.count === 0">
                    {{ segment.count | statCount }}
                  </strong>
                </span>
              }
            </div>
          </div>
        }
      </div>
    </section>

    <section class="statistics-card">
      <header class="statistics-card__header">
        <h2>{{ 'statistics.trend.title' | transloco }}</h2>
      </header>

      @if (trendLoading && trend.length === 0) {
        <p-skeleton height="8rem"></p-skeleton>
      } @else if (trend.length) {
        <div class="statistics-overview__trend">
          <p-chart
            type="bar"
            [data]="trendData"
            [options]="trendOptions"
            (onDataSelect)="onTrendSelect($event)">
          </p-chart>
        </div>
      } @else {
        <p class="statistics-card__hint">{{ 'statistics.trend.unavailable' | transloco }}</p>
      }
    </section>
  </div>

  <div class="statistics-overview__table-head">
    <h2>{{ 'statistics.table.title' | transloco }}</h2>
    <span class="statistics-card__hint">{{ 'statistics.table.hint' | transloco }}</span>

    <div class="statistics-overview__table-options">
      <p-selectbutton
        [options]="sortOptions"
        [ngModel]="sortBySize"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        (onChange)="sortBySizeChange.emit($event.value)">
      </p-selectbutton>

      <label class="statistics-overview__toggle">
        <p-toggleswitch
          [ngModel]="hideEmptyCategories"
          (ngModelChange)="hideEmptyCategoriesChange.emit($event)">
        </p-toggleswitch>
        {{ 'statistics.table.hideEmpty' | transloco }}
      </label>

      <label class="statistics-overview__toggle" [class.statistics-overview__toggle--disabled]="!hasPreviousYear">
        <p-toggleswitch
          [ngModel]="compareWithPreviousYear"
          [disabled]="!hasPreviousYear"
          (ngModelChange)="compareWithPreviousYearChange.emit($event)">
        </p-toggleswitch>
        {{ 'statistics.table.compare' | transloco: {year: previousYearLabel} }}
      </label>
    </div>
  </div>

  <app-statistics-category-table
    [response]="response"
    [rows]="rows"
    [startLabel]="startLabel"
    [endLabel]="endLabel"
    [sortBySize]="sortBySize"
    [hideEmptyCategories]="hideEmptyCategories"
    [compareWithPreviousYear]="compareWithPreviousYear"
    (showDataQuality)="scrollToDataQuality()">
  </app-statistics-category-table>

  <app-statistics-data-quality
    #dataQualitySection
    [dataQuality]="response.dataQuality"
    [year]="response.year">
  </app-statistics-data-quality>
</div>
